export const globalFontStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
`;

export const typography = {
  fontFamilies: {
    inter: "'Inter', sans-serif",
    dmSans: "'DM Sans', sans-serif"
  },

  display: {
    xl: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 72,
      fontWeight: 200,
      letterSpacing: 0,
      lineHeight: 1.3
    },
    lg: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 60,
      fontWeight: 200,
      letterSpacing: 0,
      lineHeight: 1.3
    },
    md: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 48,
      fontWeight: 200,
      letterSpacing: 0,
      lineHeight: 1.3
    }
  },

  heading: {
    xl: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 16,
      fontWeight: 200,
      letterSpacing: -0.02,
      lineHeight: 1.3
    },
    lg: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 16,
      fontWeight: 200,
      letterSpacing: -0.02,
      lineHeight: 1.3
    },
    md: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 16,
      fontWeight: 200,
      letterSpacing: -0.02,
      lineHeight: 1.3
    },
    sm: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 16,
      fontWeight: 200,
      letterSpacing: -0.02,
      lineHeight: 1.3
    }
  },

  body: {
    xl: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 14,
      fontWeight: 200,
      letterSpacing: -0.02,
      lineHeight: 28
    },
    lg: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 14,
      fontWeight: 200,
      letterSpacing: -0.02,
      lineHeight: 26
    },
    md: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 14,
      fontWeight: 200,
      letterSpacing: -0.02,
      lineHeight: 20
    },
    sm: {
      fontFamily: "'Inter', sans-serif",
      fontSize: 14,
      fontWeight: 200,
      letterSpacing: -0.02,
      lineHeight: 20
    }
  },

  label: {
    fontFamily: "'Inter', sans-serif",
    fontSize: 14,
    fontWeight: 200,
    letterSpacing: -0.02,
    lineHeight: 18
  }
};
